@file:OptIn(ExperimentalMaterialApi::class, ExperimentalMaterialApi::class,
    ExperimentalMaterialApi::class
)

package demos.switch

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.Orientation
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.material.FractionalThreshold
import androidx.compose.material.rememberSwipeableState
import androidx.compose.material.swipeable
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.RoundRect
import androidx.compose.ui.geometry.toRect
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Outline
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.PathMeasure
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.addOutline
import androidx.compose.ui.graphics.drawOutline
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import kotlin.math.roundToInt


const val LOOP_SWITCH = "c24d78e2135fa29cfdc4fa39b777794e5baaac573c4ccdf9551ddc87fa6240df"

@Composable
fun LoopSwitch() {
    val totalWidth = 192.dp
    val thumbSize = 96.dp
    val strokeWidth = 80f
    val swipeState = rememberSwipeableState(0)
    val thumbSizePx = with(LocalDensity.current) { thumbSize.toPx() }
    val anchors = mapOf(0f to 0, thumbSizePx to 1)
    val scope = rememberCoroutineScope()
    Box(
        modifier = Modifier
            .width(totalWidth)
            .drawBehind {
                val outline = Outline.Rounded(
                    RoundRect(
                        size.toRect(),
                        CornerRadius(size.height, size.height)
                    )
                )
                val measure = PathMeasure().apply {
                    setPath(Path().apply { addOutline(outline) }, false)
                }

                drawOutline(
                    outline,
                    color = Color.Gray.copy(alpha = .1f),
                    style = Stroke(
                        width = strokeWidth,
                    )
                )

                val progress = swipeState.offset.value / thumbSizePx

                drawOutline(
                    outline,
                    color = Color.White.copy(alpha = (.3f + (.7f * progress)).coerceAtMost(1f)),
                    style = Stroke(
                        width = strokeWidth,
                        cap = StrokeCap.Round,
                        join = StrokeJoin.Round,
                        pathEffect = PathEffect.dashPathEffect(
                            intervals = floatArrayOf((measure.length / 2), measure.length / 2),
                            phase = -(size.width - size.height) / 2 - ((measure.length / 2) * (1f + progress))
                        )
                    )
                )
            }
            .pointerInput(Unit) {
                detectTapGestures {
                    scope.launch {
                        swipeState.animateTo(
                            targetValue = if (swipeState.targetValue == 0) 1 else 0,
                            anim = spring(
                                stiffness = Spring.StiffnessLow,
                                dampingRatio = Spring.DampingRatioLowBouncy
                            )
                        )
                    }
                }
            }
            .swipeable(
                state = swipeState,
                anchors = anchors,
                thresholds = { _, _ -> FractionalThreshold(0.3f) },
                orientation = Orientation.Horizontal
            )
    ) {
        Box(
            Modifier
                .offset { IntOffset(swipeState.offset.value.roundToInt(), 0) }
                .size(thumbSize)
                .padding(20.dp)
                .background(
                    Color.White.copy(
                        alpha = (.5f + (.5f * (swipeState.offset.value / thumbSizePx))).coerceAtMost(
                            1f
                        )
                    ),
                    shape = CircleShape
                )
        )
    }
}